<template>
  <f7-page  no-swipeback name="financial" class="page-center" 
  infinite
  :infinite-distance="50"
  :infinite-preloader="showPreloader"
  @infinite="loadMore"
  >
    <f7-navbar innerClass="navbar-inner">
      <!-- <f7-nav-left>
        <f7-link @click="$f7router.back()">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left> -->
      <f7-nav-title>{{ $t("home_0178") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block class="block-banner" style="margin: 18px 0;" v-if="bannerShow">
      <f7-swiper :pagination="bannerList.length>1"  next-button prev-button data-lazy="{'enabled': true}" :params="swiperParams" class="swiper-banner" >
        <f7-swiper-slide v-for="(item, index) in bannerList" :key="index" style="font-size: 0px;">
          <img :src="`${bannerBaseUri + item.Url}`" class="swiper-lazy" width="100%" />
          <div class="preloader swiper-lazy-preloader"></div>
        </f7-swiper-slide>
        <div class="swiper-pagination"></div>
      </f7-swiper>
    </f7-block>
    <div class="content" v-if="newsbymemberlist.length>0">
      <div class="newsInfo" v-for="(item,index) in newsbymemberlist" :key="index" >
        <div class="img" @click="$f7router.navigate(`/newsDetail/${item.Id}/1/`)"><img width="100%" :src="`${ImagesURL}sr/picture/promotion/${item.PosterMobile}`" ></div>
        <div class="bottom" style="padding:0 10px;">
          <div class="title" @click="$f7router.navigate(`/newsDetail/${item.Id}/1/`)">{{ item.Title }}</div>
          <div class="time">
            <span>{{ item.ReleaseTS | time2}}</span>
            <span class="good" @click="newsLike(item.Id,!getOne(item.Id)[1])">
              <img  width="16" :src="`../../static/images/yt999/${(likecountlist.find(i => i.k == item.Id) && likecountlist.find(i => i.k == item.Id).v[1])
              ? 'good2' 
              : 'good'}.png`"  />
              <span style="margin-left: 4px;">{{ getOne(item.Id)[0] }}</span>
            </span>

          </div>
        </div>
      </div>

    </div>
    <f7-card v-else-if="newsbymemberlist.length<=0 && !showData" class="no-data">
      <img :src="`../../static/images/yt999/noData_${ $f7.params.currLang }.png`" width="45%" :onerror="`this.onerror=''; src='../../static/images/yt999/noData_enUS.png'`" alt="No data" >
    </f7-card>

  </f7-page>
</template>

<script>
import { getStore } from "@/config/utils";
import {merchantMewsList,getCarouseladvertList,getlikecount, newsLike  } from "../../axios/api";


export default {
  components: {},
  props: {},
  data() {
    return {
      ImagesURL: getStore('ImagesURL'),
      newsbymemberlist: [],
      allowInfinite: true,
      showPreloader: true,
      pageNow: 1,
      pageTotal: 0,
      showData: true,
      data: [],


      bannerList: [],
      bannerBaseUri: "",
      bannerShow: false,
      swiperParams: {
        speed: 700,
        loop: true,
        // autoplay: {
        //   disableOnInteraction: false,
        //   delay: 8000,
        // },
        lazy: {
          loadPrevNext: true,
        },
      },
      likecountlist: [],
      likeFlag: true,
    };
  },
  watch: {},
  computed: {},
  methods: {
    getnewsbymemberlist(){
      const self = this;
      const param = {"NewsType":1,"IsHot":false,"PageSize":50,"PageNow":self.pageNow};
      const d =  JSON.stringify(param) ;
      merchantMewsList(d).then((data) => {
        if (data.Code === "NoError") {
          self.data = data.Data;
          self.newsbymemberlist = self.newsbymemberlist.concat(
            data.Data
          );
          self.showData = self.newsbymemberlist.length > 0;

          self.showPreloader = false;
        }
        self.getlikecount();
      });
    },
    getOne(id){
      const item = this.likecountlist.find(i => i.k === id);
      return item ? item.v : [];
      
    },
    getlikecount(){
      const idList = this.newsbymemberlist.map(item => item.Id);
      const d = { data: JSON.stringify(idList) };
      getlikecount(d).then((data) => {
        if (data.Code === "NoError") {
          this.likecountlist = data.Data;
        }
      });

    },

    loadMore() {
      const self = this;
      if (!self.allowInfinite) return;
      self.allowInfinite = false;

      self.showPreloader = true;
      setTimeout(() => {
        console.log(self.data.length)
        if (self.data.length == 0) {
          self.showPreloader = false;
          return;
        }
        self.pageNow += 1;
        self.getnewsbymemberlist();
        self.allowInfinite = true;
      }, 1000);
    },
    getBannerList(param) {
      const self = this;
      getCarouseladvertList(param).then((data) => {
        if (data.Code === "NoError") {
          
          self.bannerList = data.Data;
          if (self.bannerList.length>1) {
            self.bannerShow = true;
            self.swiperParams.autoplay = { disableOnInteraction: false, delay: 5000 }
          }
        }
      });
    },
    newsLike(id,flag){
      if (!this.likeFlag) {
        return;
      }
      this.likeFlag = false;

      const param = {"newsID":id,"isLike":flag};
      const d = { data: JSON.stringify(param) };
      newsLike(d).then((data) => {
        if (data.Code === "NoError") {
          this.getlikecount();
          // console.log(this.likecountlist); 
        }
        this.likeFlag = true;
      });
    }
  },
  created() { 
    this.getBannerList(7);
    this.bannerBaseUri = getStore("ImagesURL") + window.configs.carouseladvertImg;
    this.getnewsbymemberlist();
    this.$f7.emit("myCustomEvent", "newsList");

  },
  mounted() { 
    
  },
};
</script>
<style lang="less" scoped>
.content{
  padding: 0 10px 25px 10px;
  .newsInfo:nth-child(1){
    margin-top: 10px;
  }
  .newsInfo{
    margin: 0 auto;
    border: 1px solid #cccccc;
    border-radius: 8px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    .img{
      font-size: 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 200px;
      margin-bottom: 10px;
      border-bottom: 1px solid #e5e5e5;
      border-radius: 8px 8px 0 0;
    }
    .bottom{
      .title{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;   
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 20px;       
        max-height: 40px;  
        
      }
      .time{
        color: rgba(153, 153, 153, 1);
        font-size: 12px;
        position: relative;
      }
      .good{
        position: absolute;
        right: 0px;
        bottom: 0px;
        display: flex;
        align-items: center;
      }
    }
  }
}
.no-data {
    background-color: transparent;
    box-shadow: none;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 50%;
}
</style>